import React from 'react';
import moment from 'moment-timezone';
export default class DateHelper{
	constructor(date){
		this.monthNames = [
			'Jan',
			'Feb',
			'Mar',
			'Apr',
			'May',
			'Jun',
			'Jul',
			'Aug',
			'Sep',
			'Oct',
			'Nov',
			'Dec'
		];

		this.dayNames = [
			'Sun',
			'Mon',
			'Tue',
			'Wed',
			'Thu',
			'Fri',
			'Sat'
		];

		this.date = moment(date);

	}

	getWeekRange(fromDate){
		//let today = moment(fromDate).hour(0).minute(0); // || new Date();
		let weekStart = moment(fromDate).startOf('week').startOf('day');  //today.day(0).hour(0).minute(0).clone();// new Date(today.getTime());
		let weekEnd = moment(fromDate).endOf('week').endOf('day');// today.day(6).hour(23).minute(59).clone();// new Date(today.getTime());

		return [weekStart, weekEnd];

		//this.setState({weekRange:});
	}

	static GetRange(fromDate, range= 'week') {
		let start = moment(fromDate).startOf(range).startOf('day');  //today.day(0).hour(0).minute(0).clone();// new Date(today.getTime());
		let end = moment(fromDate).endOf(range).endOf('day');// today.day(6).hour(23).minute(59).clone();// new Date(today.getTime());

		return [start, end];
	}

	static GetWeekRange(fromDate){
		let weekStart = moment(fromDate).startOf('week').startOf('day');
		let weekEnd = moment(fromDate).endOf('week').endOf('day');

		return [weekStart, weekEnd];
	}

	rangeToString(dateRange){
		let depth = 0;
		let endOrder = ['d', 'y'];
		let startOrder = ['m', 'd'];

		console.log("DateRageToString:", dateRange)

		if(dateRange[0].month() != dateRange[1].month()){
			depth = 1;
			endOrder = ['m', 'd', 'y'];
		}

		if(dateRange[0].year() != dateRange[1].year()){
			endOrder = ['m', 'd', 'y'];
			startOrder = ['m', 'd', 'y'];
		}




		let start = this.dateToString(dateRange[0], 3, startOrder);
		let end = this.dateToString(dateRange[1], 3, endOrder);

		return start + " - " + end ;
	}

	dateToString(d, depth, order){
		//depth day(0), month(1), year(2);
		let depthOrder = ['d', 'm', 'y'];
		let odr = order || ['m', 'd', 'y'];
		let dpth = depth || odr.length;



		let s = [];
		for(let i=0; i < dpth; i++){
			let p = odr[i];
			if(p){
				switch(p){
				case 'm':
					s.push(d.format('MMMM') + ' ');
					break;
				case 'd':
					s.push(d.format('D'));
					break;
				case 'y':
					s.push(', ' + d.format('YYYY'));
					break;
				}
			}else{
				break;
			}
		}

		return s.join('');
	}

	gotoNextWeek(){
		let weekEnd = moment(this.state.date);// this.getWeekRange(this.state.date)[1];
		weekEnd.day(7);

		return weekEnd;

	}

	gotoPrevWeek(){
		let weekStart = moment(this.state.date);// this.getWeekRange(this.state.date)[0];
		weekStart.day(-1);
		return weekStart;
	}

	static dateToString(date){
		let d = moment(date);
		return d.format("YYYY-MM-DD");
		//return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
	}

	static DateToServerString(date){
		let d = moment(date);
		//console.log('TimeZone Test:', d.tz(moment.tz.guess()).format(), '  or:', d.tz(moment.tz.guess()).format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS));
		return d.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
	}

	static FormatTime(d){
		let t = moment(d);
		let hour = t.hour();
		let min = t.minute();
		let ampm = hour < 12? 'am' : 'pm';
		let hourDisp = hour > 12? hour - 12: hour;
		if(min){
			min = min < 10? 0 + '' + min : min;
			return hourDisp + ':' + min + ' ' + ampm;
		}

		return hourDisp + ' ' + ampm;
	}

	static isSameDay(d1, d2){
		return moment(d1).format('YYYY/M/D') === moment(d2).format('YYYY/M/D');
	}

}



// WEBPACK FOOTER //
// ./src/components/DateHelper.js